<template>
    <div>
        <button
                v-on:click="swap"
                v-bind:disabled="swapping"
                class="btn btn-primary full-width">
            {{ 'Do this job now' | trans }}
        </button>
        <div
                v-if="errorMessage !== null"
                class="alert alert-danger">
            {{ 'Error' | trans }} - {{ errorMessage }}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            job: Object,
        },
        data() {
            return {
                swapping: false,
                errorMessage: null,
            };
        },
        methods: {
            async swap() {
                if (this.swapping === true) { // theoretically useless guard...
                    return;
                }
                this.swapping = true;
                this.errorMessage = null;
                try {
                    const swapped = await this.$api.job.swap(this.job.id, this.job.shouldBeSwappableWithJobId);
                    if (swapped === false) {
                        this.errorMessage = this.$options.filters.trans('Not allowed to do this job now');
                    }
                    else {
                        this.$emit('swapped');
                    }
                }
                catch (error) {
                    if (this.$api.is401(error)) {
                        // in case of 401, just abort javascript execution
                        return;
                    }
                    if (this.$api.isNoConnectivity(error)) {
                        this.errorMessage = this.$options.filters.trans('No connection ?');
                    } else {
                        this.$bugsnagClient.notify(error);
                        this.errorMessage = this.$options.filters.trans('Unknown error');
                    }
                }
                this.swapping = false;
            },
        },
    }
</script>
